module.exports = __webpack_public_path__ + "img/house.fb883b4f.webp";